export const formUserManagementNaming = {
  NEW_USER_MANAGEMENT_FORM: 'new-user-management-form',
};
